module.exports = __webpack_public_path__ + "assets/img/4.d3660d51.png";